// extracted by mini-css-extract-plugin
module.exports = {"minutes":"_1rxvb-q","capitalize":"_2lPMzqy"};